module.exports = __webpack_public_path__ + "static/img/legend_xg_spanish.3c07bad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xg_spanish.png
// module id = CHjW
// module chunks = 94